'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.PushCart = PushCart;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _windowWidth = require('../../hooks/window-width');

var _functional = require('../../../utils/functional');

var _i18n = require('../../../services/i18n');

var _Ui = require('../Ui');

var _PushCartBody = require('./PushCartBody');

var _PushCartUpsell = require('./PushCartUpsell');

var _PushCartDeliveryBar = require('./PushCartDeliveryBar');

var _PushCartErrors = require('./PushCartErrors');

var _PushCartFooter = require('./PushCartFooter');

var _PushCartTopBar = require('./PushCartTopBar');

var _utils = require('./utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var backgroundTopRight = window.theme.cart.topRightDecalImage;
var backgroundBottomLeft = window.theme.cart.bottomLeftDecalImage;

function PushCart(_ref) {
  var _this = this;

  var action = _ref.action,
      submitTo = _ref.submitTo,
      message = _ref.message,
      subtitle = _ref.subtitle,
      cards = _ref.cards,
      upsellTitle = _ref.upsellTitle,
      upsellProducts = _ref.upsellProducts,
      productLimit = _ref.productLimit;

  var topBarRef = (0, _react.useRef)(null);
  var deliveryBarRef = (0, _react.useRef)(null);
  var bodyRef = (0, _react.useRef)(null);
  var upsellRef = (0, _react.useRef)(null);
  var footerRef = (0, _react.useRef)(null);

  var _useWindowSize = (0, _windowWidth.useWindowSize)(),
      windowHeight = _useWindowSize.windowHeight;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      scrollableHeight = _useState2[0],
      setScrollableHeight = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      shippingCost = _useState4[0],
      setShippingCost = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray3.default)(_useState5, 2),
      expandUpsell = _useState6[0],
      setExpandUpsell = _useState6[1];

  var errors = (0, _reactRedux.useSelector)(function (state) {
    return state.pushCart.errors;
  });
  var loading = (0, _reactRedux.useSelector)(function (state) {
    return state.pushCart.loading;
  });
  var lineItems = (0, _reactRedux.useSelector)(function (state) {
    return state.pushCart.lineItems;
  });
  var itemCount = (0, _reactRedux.useSelector)(function (state) {
    return state.pushCart.itemCount;
  });
  var upsellItems = (0, _reactRedux.useSelector)(function (state) {
    return (0, _utils.filterUpsellProducts)(state.pushCart.lineItems, upsellProducts, productLimit);
  });

  var lineItemsWithoutFreeGifts = lineItems.filter(function (lineItem) {
    return !(0, _utils.isLineItemFreeGift)(lineItem);
  });

  var lineItemsWithMixMatchChildren = lineItems.filter(function (lineItem) {
    return lineItem.properties !== null && lineItem.properties.__MixAndMatchChild === true;
  });

  var lineItemsWithMixMatchFirstChild = lineItems.filter(function (lineItem) {
    return lineItem.properties !== null && lineItem.properties.__MixAndMatchChildIsFirst === true;
  });

  var itemCountWithoutFreeGifts = lineItemsWithoutFreeGifts.reduce(function (count, lineItem) {
    return count + lineItem.quantity;
  }, 0);
  var itemCountMixMatchChildren = lineItemsWithMixMatchChildren.reduce(function (count, lineItem) {
    return count + lineItem.quantity;
  }, 0);

  // For the first child of a Mix & Match product, we only show a single item count, regardless of quantity added
  var itemCountMixMatchFirstChild = lineItemsWithMixMatchFirstChild.length;

  var cartIsEmpty = itemCountWithoutFreeGifts === 0;

  function getScrollableHeight() {
    return windowHeight - (topBarRef.current ? topBarRef.current.offsetHeight : 0) - (deliveryBarRef.current ? deliveryBarRef.current.offsetHeight : 0) - (footerRef.current ? footerRef.current.offsetHeight : 0) - (upsellRef.current ? upsellRef.current.offsetHeight : 0);
  }

  (0, _react.useLayoutEffect)(function () {
    if (cartIsEmpty === false) {
      setScrollableHeight(getScrollableHeight());
    }
  }, [windowHeight, cartIsEmpty, expandUpsell]);

  (0, _react.useEffect)(function () {
    (0, _functional.getElements)('[data-cart-count]').forEach(function (el) {
      el.textContent = itemCountWithoutFreeGifts - itemCountMixMatchChildren + itemCountMixMatchFirstChild;
    });
    setScrollableHeight(getScrollableHeight());
  }, [itemCount]);

  (0, _react.useEffect)(function () {
    var _window$theme$custome = window.theme.customer,
        isLoggedIn = _window$theme$custome.isLoggedIn,
        defaultAddress = _window$theme$custome.defaultAddress;

    if (!isLoggedIn) return;
    if (defaultAddress == null) return;

    var getShippingRates = function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var zip, country, _defaultAddress$provi, province, json, rates;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                zip = defaultAddress.zip, country = defaultAddress.country, _defaultAddress$provi = defaultAddress.province, province = _defaultAddress$provi === undefined ? '' : _defaultAddress$provi;
                _context.prev = 1;
                _context.next = 4;
                return (0, _functional.fetchJSON)(encodeURI('/cart/shipping_rates.json?shipping_address[zip]=' + zip + '&shipping_address[country]=' + country + '&shipping_address[province]=' + province));

              case 4:
                json = _context.sent;
                rates = json.shipping_rates;

                if (!(rates.length === 0)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return');

              case 8:

                setShippingCost(parseFloat(rates[0].price) * 100);
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](1);

                console.info('There are no shipping rates for your address');

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 11]]);
      }));

      return function getShippingRates() {
        return _ref2.apply(this, arguments);
      };
    }();

    getShippingRates();
  }, [lineItems]);

  if (cartIsEmpty) {
    return _react2.default.createElement('div', { className: 'psh-Cart' + (loading ? ' psh-Cart-loading' : '') }, _react2.default.createElement('header', { className: 'psh-Cart_TopBar', ref: topBarRef }, _react2.default.createElement(_PushCartTopBar.PushCartTopBar, null)), _react2.default.createElement('div', { className: 'psh-Cart_Body', ref: bodyRef }, _react2.default.createElement('div', { className: 'psh-Cart_Empty' }, _react2.default.createElement('div', { className: 'psh-Cart_EmptyContent' }, _react2.default.createElement('p', { className: 'psh-Cart_EmptyTitle' }, (0, _i18n.t)('cart.general.text')), subtitle && _react2.default.createElement('p', { className: 'psh-Cart_EmptySubtitle' }, subtitle), cards.length > 0 ? cards.map(function (card) {
      return _react2.default.createElement('a', { href: card.href, className: 'psh-Cart_Card', key: card.title }, _react2.default.createElement('div', {
        className: 'psh-Cart_CardImage',
        style: {
          backgroundImage: 'url(' + card.mainImage + ')'
        }
      }), _react2.default.createElement('h4', { className: 'psh-Cart_CardTitle' }, card.title));
    }) : _react2.default.createElement(_Ui.Button, { className: 'psh-Cart_EmptyButton', 'data-module-drawers-close': 'cart' }, (0, _i18n.t)('cart.drawer.continue_shopping'))), _react2.default.createElement('div', { className: 'psh-Cart_EmptyImageContainer psh-Cart_EmptyImageContainer-topRight' }, _react2.default.createElement('img', { className: 'psh-Cart_EmptyImage', src: backgroundTopRight })), _react2.default.createElement('div', { className: 'psh-Cart_EmptyImageContainer psh-Cart_EmptyImageContainer-bottomLeft' }, _react2.default.createElement('img', { className: 'psh-Cart_EmptyImage', src: backgroundBottomLeft })))));
  }

  return _react2.default.createElement('div', { className: 'psh-Cart' + (loading ? ' psh-Cart-loading' : '') }, errors.length > 0 && _react2.default.createElement('div', { className: 'psh-Cart_Errors' }, _react2.default.createElement(_PushCartErrors.PushCartErrors, { errors: errors })), _react2.default.createElement('header', { className: 'psh-Cart_TopBar', ref: topBarRef }, _react2.default.createElement(_PushCartTopBar.PushCartTopBar, { title: (0, _i18n.t)('cart.drawer.title') })), _react2.default.createElement('div', { className: 'psh-Cart_Delivery', ref: deliveryBarRef }, _react2.default.createElement(_PushCartDeliveryBar.PushCartDeliveryBar, null)), _react2.default.createElement('div', {
    className: 'psh-Cart_Main',
    style: {
      height: scrollableHeight + 'px'
    }
  }, _react2.default.createElement('div', { className: 'psh-Cart_Body', ref: bodyRef }, _react2.default.createElement(_PushCartBody.PushCartBody, {
    lineItems: lineItems.sort(function (a) {
      if ((0, _utils.isLineItemFreeGift)(a)) {
        return 1;
      }

      return -1;
    })
  }))), upsellItems.length > 0 && _react2.default.createElement('div', { className: 'psh-Cart_Upsell', ref: upsellRef }, _react2.default.createElement(_PushCartUpsell.PushCartUpsell, {
    title: upsellTitle,
    expand: expandUpsell,
    setExpand: setExpandUpsell,
    upsellItems: upsellItems
  })), _react2.default.createElement('footer', { className: 'psh-Cart_Footer', ref: footerRef }, _react2.default.createElement(_PushCartFooter.PushCartFooter, {
    action: action,
    submitTo: submitTo,
    message: message,
    shippingCost: shippingCost
  })));
}

PushCart.defaultProps = {
  message: '',
  subtitle: null,
  cards: [],
  upsellTitle: '',
  upsellProducts: [],
  productLimit: 0
};

PushCart.propTypes = {
  action: _propTypes2.default.string.isRequired,
  submitTo: _propTypes2.default.string.isRequired,
  message: _propTypes2.default.string,
  subtitle: _propTypes2.default.string,
  cards: _propTypes2.default.array,
  upsellTitle: _propTypes2.default.string,
  upsellProducts: _propTypes2.default.array,
  productLimit: _propTypes2.default.number
};